import type {Values} from '@wix/devzai-utils-common';
import {enumGetValues, evaluateFunction} from '@wix/devzai-utils-common';

export const DoppePageLockPreviewImageAspectRatio = {
    Ratio1By1: '1:1',
    Ratio3By4: '3:4',
    Ratio4By5: '4:5',
    Ratio16By9: '16:9',
} as const;

export type DoppePageLockPreviewImageAspectRatio = Values<typeof DoppePageLockPreviewImageAspectRatio>;

export function doppePageLockPreviewImageAspectRatioGetValuesForList() {
    return enumGetValues(DoppePageLockPreviewImageAspectRatio);
}

export function doppePageLockPreviewImageAspectRatioGetWidthHeightRatio(
    aspectRatio: DoppePageLockPreviewImageAspectRatio
): number {
    return evaluateFunction(() => {
        switch (aspectRatio) {
            case DoppePageLockPreviewImageAspectRatio.Ratio1By1:
                return 1 / 1;
            case DoppePageLockPreviewImageAspectRatio.Ratio3By4:
                return 3 / 4;
            case DoppePageLockPreviewImageAspectRatio.Ratio4By5:
                return 4 / 5;
            case DoppePageLockPreviewImageAspectRatio.Ratio16By9:
                return 16 / 9;
        }
    });
}
